import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';

// Layout Components
import AdminLayout from './components/layout/AdminLayout';

// Page Components
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import LocationManagementPage from './pages/locations/LocationManagementPage';
import PackageListPage from './pages/packages/PackageListPage';
import PackageFormPage from './pages/packages/PackageFormPage';
import PkgInclusionExclusionPage from './pages/packages/PkgInclusionExclusionPage';
import FaqListPage from './pages/faqs/FaqListPage';
import FaqFormPage from './pages/faqs/FaqFormPage';
import TestimonialListPage from './pages/testimonials/TestimonialListPage';
import TestimonialFormPage from './pages/testimonials/TestimonialFormPage';
// REMOVED: import GoogleSyncConfigPage from './pages/testimonials/GoogleSyncConfigPage';
import ProfilePage from './pages/profile/ProfilePage';
import MediaManagementPage from './pages/media/MediaManagementPage';

// Private Route Component for authentication protection
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-xl font-semibold text-gray-700">Loading authentication...</div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <AdminLayout /> {/* AdminLayout will contain nested routes */}
                </PrivateRoute>
              }
            >
              {/* Default redirect to Dashboard after login */}
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />

              {/* Content Management */}
              <Route path="locations" element={<LocationManagementPage />} />
              <Route path="media" element={<MediaManagementPage />} />
              <Route path="packages" element={<PackageListPage />} />
              <Route path="packages/new" element={<PackageFormPage />} />
              <Route path="packages/edit/:id" element={<PackageFormPage />} />
              <Route path="pkg-inclusion-exclusion" element={<PkgInclusionExclusionPage />} />
              <Route path="faqs" element={<FaqListPage />} />
              <Route path="faqs/new" element={<FaqFormPage />} />
              <Route path="faqs/edit/:id" element={<FaqFormPage />} />
              <Route path="testimonials" element={<TestimonialListPage />} />
              <Route path="testimonials/new" element={<TestimonialFormPage />} />
              <Route path="testimonials/edit/:id" element={<TestimonialFormPage />} />
              {/* REMOVED: <Route path="testimonials/google-sync" element={<GoogleSyncConfigPage />} /> */}
              <Route path="profile" element={<ProfilePage />} />
              
              {/* Catch-all for unknown paths within AdminLayout */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>

            {/* Fallback for any unmatched routes */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;